<template>
    <div>

      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>内部管理</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>成本核算</el-breadcrumb-item>
      </el-breadcrumb>

      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="清单列表" name="first">
          <!-- 查询 start -->
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
            <el-form-item label="">
              <el-select v-model="keywords.bomsn" placeholder="请选择项目" class="select" style="width: 150px;">
                <el-option label="请选择项目" value="0"></el-option>
                <el-option
                  v-for="item in projectlist" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="apiProjectcostlist">查询</el-button>
              <el-button type="success" @click="apiEditProjectcost" v-if="SubRule_Caiwu_EditProjectcost">保存</el-button>
            </el-form-item>
          </el-form>
          <!-- 查询 end -->
        </el-tab-pane>

        <div class="case" ref="box">
          <img class="caseimg1" src="../../assets/images/table_erpprojectcost.png">
          <div class="caseword">
            <el-input class="num1 rt-input" v-model="num1" placeholder="请输入数量" @change="processData()"></el-input>
            <el-input class="num2 rt-input" v-model="num2" placeholder="请输入数量" @change="processData()"></el-input>
            <el-input class="num3 rt-input" v-model="num3" placeholder="请输入数量" @change="processData()"></el-input>
            <el-input class="num4 rt-input" v-model="num4" placeholder="请输入数量" @change="processData()"></el-input>
            <el-input class="num5 rt-input" v-model="num5" placeholder="请输入数量" @change="processData()"></el-input>
            <el-input class="num6 rt-input" v-model="num6" placeholder="请输入数量" @change="processData()"></el-input>
            <el-input class="quantity1 rt-input" v-model="quantity" placeholder="请输入月产能" @change="processData()"></el-input>
            <el-input class="quantity2 rt-input" v-model="quantity" @change="processData()" ></el-input>
            <el-input class="quantity3 rt-input" v-model="quantity" @change="processData()" ></el-input>
            <el-input class="quantity4 rt-input" v-model="quantity" @change="processData()" ></el-input>
            <el-input class="quantity5 rt-input" v-model="quantity" @change="processData()" ></el-input>
            <el-input class="quantity6 rt-input" v-model="quantity" @change="processData()" ></el-input>
            <el-input class="cailiao1 rt-input" v-model="cailiao" :disabled="true"></el-input>
            <el-input class="cailiao2 rt-input" v-model="cailiao" :disabled="true"></el-input>
            <el-input class="cailiao3 rt-input" v-model="cailiao" :disabled="true"></el-input>
            <el-input class="cailiao4 rt-input" v-model="cailiao" :disabled="true"></el-input>
            <el-input class="cailiao5 rt-input" v-model="cailiao" :disabled="true"></el-input>
            <el-input class="cailiao6 rt-input" v-model="cailiao" :disabled="true"></el-input>
            <el-input class="unitoftime1 rt-input" v-model="unitoftime" placeholder="请输入单位工时" @change="processData()"></el-input>
            <el-input class="unitoftime2 rt-input" v-model="unitoftime"  @change="processData()"></el-input>
            <el-input class="unitoftime3 rt-input" v-model="unitoftime"  @change="processData()"></el-input>
            <el-input class="unitoftime4 rt-input" v-model="unitoftime"  @change="processData()"></el-input>
            <el-input class="unitoftime5 rt-input" v-model="unitoftime"  @change="processData()"></el-input>
            <el-input class="unitoftime6 rt-input" v-model="unitoftime"  @change="processData()"></el-input>
            <el-input class="hourlywage1 rt-input" v-model="hourlywage" placeholder="请输入小时工资" @change="processData()"></el-input>
            <el-input class="hourlywage2 rt-input" v-model="hourlywage"  @change="processData()"></el-input>
            <el-input class="hourlywage3 rt-input" v-model="hourlywage"  @change="processData()"></el-input>
            <el-input class="hourlywage4 rt-input" v-model="hourlywage"  @change="processData()"></el-input>
            <el-input class="hourlywage5 rt-input" v-model="hourlywage"  @change="processData()"></el-input>
            <el-input class="hourlywage6 rt-input" v-model="hourlywage"  @change="processData()"></el-input>
            <el-input class="rengongxiaoji1  rt-input" v-model="rengongxiaoji" :disabled="true"></el-input>
            <el-input class="rengongxiaoji2  rt-input" v-model="rengongxiaoji" :disabled="true"></el-input>
            <el-input class="rengongxiaoji3  rt-input" v-model="rengongxiaoji" :disabled="true"></el-input>
            <el-input class="rengongxiaoji4  rt-input" v-model="rengongxiaoji" :disabled="true"></el-input>
            <el-input class="rengongxiaoji5  rt-input" v-model="rengongxiaoji" :disabled="true"></el-input>
            <el-input class="rengongxiaoji6  rt-input" v-model="rengongxiaoji" :disabled="true"></el-input>
            <el-input class="mouldcost1 rt-input" v-model="mouldcost" placeholder="请输入模具费" @change="processData()"></el-input>
            <el-input class="mouldcost2 rt-input" v-model="mouldcost"  @change="processData()"></el-input>
            <el-input class="mouldcost3 rt-input" v-model="mouldcost"  @change="processData()"></el-input>
            <el-input class="mouldcost4 rt-input" v-model="mouldcost"  @change="processData()"></el-input>
            <el-input class="mouldcost5 rt-input" v-model="mouldcost"  @change="processData()"></el-input>
            <el-input class="mouldcost6 rt-input" v-model="mouldcost"  @change="processData()"></el-input>
            <el-input class="mouldcostdanwei1 rt-input" v-model="mouldcostdanwei1" :disabled="true"></el-input>
            <el-input class="mouldcostdanwei2 rt-input" v-model="mouldcostdanwei2" :disabled="true"></el-input>
            <el-input class="mouldcostdanwei3 rt-input" v-model="mouldcostdanwei3" :disabled="true"></el-input>
            <el-input class="mouldcostdanwei4 rt-input" v-model="mouldcostdanwei4" :disabled="true"></el-input>
            <el-input class="mouldcostdanwei5 rt-input" v-model="mouldcostdanwei5" :disabled="true"></el-input>
            <el-input class="mouldcostdanwei6 rt-input" v-model="mouldcostdanwei6" :disabled="true"></el-input>
            <el-input class="developmentfee1 rt-input" v-model="developmentfee" placeholder="请输入开发费" @change="processData()"></el-input>
            <el-input class="developmentfee2 rt-input" v-model="developmentfee"  @change="processData()"></el-input>
            <el-input class="developmentfee3 rt-input" v-model="developmentfee"  @change="processData()"></el-input>
            <el-input class="developmentfee4 rt-input" v-model="developmentfee"  @change="processData()"></el-input>
            <el-input class="developmentfee5 rt-input" v-model="developmentfee"  @change="processData()"></el-input>
            <el-input class="developmentfee6 rt-input" v-model="developmentfee"  @change="processData()"></el-input>
            <el-input class="developmentfeedanwei1 rt-input" v-model="developmentfeedanwei1" :disabled="true"></el-input>
            <el-input class="developmentfeedanwei2 rt-input" v-model="developmentfeedanwei2" :disabled="true"></el-input>
            <el-input class="developmentfeedanwei3 rt-input" v-model="developmentfeedanwei3" :disabled="true"></el-input>
            <el-input class="developmentfeedanwei4 rt-input" v-model="developmentfeedanwei4" :disabled="true"></el-input>
            <el-input class="developmentfeedanwei5 rt-input" v-model="developmentfeedanwei5" :disabled="true"></el-input>
            <el-input class="developmentfeedanwei6 rt-input" v-model="developmentfeedanwei6" :disabled="true"></el-input>
            <el-input class="zulingfei1 rt-input" v-model="zulingfei" :disabled="true"></el-input>
            <el-input class="zulingfei2 rt-input" v-model="zulingfei" :disabled="true"></el-input>
            <el-input class="zulingfei3 rt-input" v-model="zulingfei" :disabled="true"></el-input>
            <el-input class="zulingfei4 rt-input" v-model="zulingfei" :disabled="true"></el-input>
            <el-input class="zulingfei5 rt-input" v-model="zulingfei" :disabled="true"></el-input>
            <el-input class="zulingfei6 rt-input" v-model="zulingfei" :disabled="true"></el-input>
            <el-input class="dianfei1 rt-input" v-model="dianfei" :disabled="true"></el-input>
            <el-input class="dianfei2 rt-input" v-model="dianfei" :disabled="true"></el-input>
            <el-input class="dianfei3 rt-input" v-model="dianfei" :disabled="true"></el-input>
            <el-input class="dianfei4 rt-input" v-model="dianfei" :disabled="true"></el-input>
            <el-input class="dianfei5 rt-input" v-model="dianfei" :disabled="true"></el-input>
            <el-input class="dianfei6 rt-input" v-model="dianfei" :disabled="true"></el-input>
            <el-input class="freight1 rt-input" v-model="freight" placeholder="请输入运费" @change="processData()"></el-input>
            <el-input class="freight2 rt-input" v-model="freight"  @change="processData()"></el-input>
            <el-input class="freight3 rt-input" v-model="freight"  @change="processData()"></el-input>
            <el-input class="freight4 rt-input" v-model="freight"  @change="processData()"></el-input>
            <el-input class="freight5 rt-input" v-model="freight"  @change="processData()"></el-input>
            <el-input class="freight6 rt-input" v-model="freight"  @change="processData()"></el-input>
            <el-input class="other1  rt-input" v-model="other" :disabled="true"></el-input>
            <el-input class="other2  rt-input" v-model="other" :disabled="true"></el-input>
            <el-input class="other3  rt-input" v-model="other" :disabled="true"></el-input>
            <el-input class="other4  rt-input" v-model="other" :disabled="true"></el-input>
            <el-input class="other5  rt-input" v-model="other" :disabled="true"></el-input>
            <el-input class="other6  rt-input" v-model="other" :disabled="true"></el-input>
            <el-input class="otherxiaoji1  rt-input" v-model="otherxiaoji1" :disabled="true"></el-input>
            <el-input class="otherxiaoji2  rt-input" v-model="otherxiaoji2" :disabled="true"></el-input>
            <el-input class="otherxiaoji3  rt-input" v-model="otherxiaoji3" :disabled="true"></el-input>
            <el-input class="otherxiaoji4  rt-input" v-model="otherxiaoji4" :disabled="true"></el-input>
            <el-input class="otherxiaoji5  rt-input" v-model="otherxiaoji5" :disabled="true"></el-input>
            <el-input class="otherxiaoji6  rt-input" v-model="otherxiaoji6" :disabled="true"></el-input>
            <el-input class="heji1 rt-input" v-model="heji1" :disabled="true"></el-input>
            <el-input class="heji2 rt-input" v-model="heji2" :disabled="true"></el-input>
            <el-input class="heji3 rt-input" v-model="heji3" :disabled="true"></el-input>
            <el-input class="heji4 rt-input" v-model="heji4" :disabled="true"></el-input>
            <el-input class="heji5 rt-input" v-model="heji5" :disabled="true"></el-input>
            <el-input class="heji6 rt-input" v-model="heji6" :disabled="true"></el-input>
          </div>
        </div>
      </el-tabs>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      // 筛选条件
      keywords: {
        bomsn: '103-0000-0002'
      },
      projectlist: [],
      activeName: 'first',
      num1: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      num5: 0,
      num6: 0,
      quantity: 0,
      cailiao: 0,
      unitoftime: 0,
      hourlywage: 0,
      mouldcost: 0,
      developmentfee: 0,
      freight: 0,

      rengongxiaoji: 0,
      mouldcostdanwei1: 0,
      mouldcostdanwei2: 0,
      mouldcostdanwei3: 0,
      mouldcostdanwei4: 0,
      mouldcostdanwei5: 0,
      mouldcostdanwei6: 0,
      developmentfeedanwei1: 0,
      developmentfeedanwei2: 0,
      developmentfeedanwei3: 0,
      developmentfeedanwei4: 0,
      developmentfeedanwei5: 0,
      developmentfeedanwei6: 0,
      zulingfei: 0,
      dianfei: 0,
      other: 0,
      otherxiaoji1: 0,
      otherxiaoji2: 0,
      otherxiaoji3: 0,
      otherxiaoji4: 0,
      otherxiaoji5: 0,
      otherxiaoji6: 0,
      heji1: 0,
      heji2: 0,
      heji3: 0,
      heji4: 0,
      heji5: 0,
      heji6: 0,
      SubRule_Caiwu_EditProjectcost: false
    }
  },
  mounted () {
    this.apiGetWorkprojectList()
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Caiwu_EditProjectcost', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Caiwu_EditProjectcost = true
      }
    })
  },
  methods: {
    apiProjectcostlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Projectcostlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.num1 = response.data.Num1
            that.num2 = response.data.Num2
            that.num3 = response.data.Num3
            that.num4 = response.data.Num4
            that.num5 = response.data.Num5
            that.num6 = response.data.Num6
            that.quantity = response.data.Quantity
            that.cailiao = that.pnum(response.data.Cailiao)
            that.unitoftime = response.data.Unitoftime
            that.hourlywage = response.data.Hourlywage
            that.mouldcost = response.data.Mouldcost
            that.developmentfee = response.data.Developmentfee
            that.freight = response.data.Freight

            that.processData()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        querytype: 1
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.projectlist = []
            response.data.List.filter((item1, i1) => {
              that.projectlist.push({ value: item1.Bomsn, label: item1.Name })
            })
            that.keywords.bomsn = that.projectlist[0].value
            that.apiProjectcostlist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditProjectcost: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.keywords.bomsn,
        num1: that.num1,
        num2: that.num2,
        num3: that.num3,
        num4: that.num4,
        num5: that.num5,
        num6: that.num6,
        quantity: that.quantity,
        unitoftime: that.unitoftime,
        hourlywage: that.hourlywage,
        mouldcost: that.mouldcost,
        developmentfee: that.developmentfee,
        freight: that.freight
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditProjectcost, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    processData () {
      this.rengongxiaoji = this.pnum(Number(this.unitoftime) * Number(this.hourlywage))
      this.mouldcostdanwei1 = this.divided(this.mouldcost, this.num1)
      this.mouldcostdanwei2 = this.divided(this.mouldcost, this.num2)
      this.mouldcostdanwei3 = this.divided(this.mouldcost, this.num3)
      this.mouldcostdanwei4 = this.divided(this.mouldcost, this.num4)
      this.mouldcostdanwei5 = this.divided(this.mouldcost, this.num5)
      this.mouldcostdanwei6 = this.divided(this.mouldcost, this.num6)

      this.developmentfeedanwei1 = this.divided(this.developmentfee, this.num1)
      this.developmentfeedanwei2 = this.divided(this.developmentfee, this.num2)
      this.developmentfeedanwei3 = this.divided(this.developmentfee, this.num3)
      this.developmentfeedanwei4 = this.divided(this.developmentfee, this.num4)
      this.developmentfeedanwei5 = this.divided(this.developmentfee, this.num5)
      this.developmentfeedanwei6 = this.divided(this.developmentfee, this.num6)

      this.zulingfei = this.divided(3900, this.quantity)
      this.dianfei = this.divided(360, this.quantity)
      this.other = this.divided(6000, this.quantity)

      this.otherxiaoji1 = this.pnum(this.mouldcostdanwei1 + this.developmentfeedanwei1 + this.zulingfei + this.dianfei + Number(this.freight) + this.other)
      this.otherxiaoji2 = this.pnum(this.mouldcostdanwei2 + this.developmentfeedanwei2 + this.zulingfei + this.dianfei + Number(this.freight) + this.other)
      this.otherxiaoji3 = this.pnum(this.mouldcostdanwei3 + this.developmentfeedanwei3 + this.zulingfei + this.dianfei + Number(this.freight) + this.other)
      this.otherxiaoji4 = this.pnum(this.mouldcostdanwei4 + this.developmentfeedanwei4 + this.zulingfei + this.dianfei + Number(this.freight) + this.other)
      this.otherxiaoji5 = this.pnum(this.mouldcostdanwei5 + this.developmentfeedanwei5 + this.zulingfei + this.dianfei + Number(this.freight) + this.other)
      this.otherxiaoji6 = this.pnum(this.mouldcostdanwei6 + this.developmentfeedanwei6 + this.zulingfei + this.dianfei + Number(this.freight) + this.other)

      this.heji1 = (this.cailiao + this.rengongxiaoji + this.otherxiaoji1).toFixed(2)
      this.heji2 = (this.cailiao + this.rengongxiaoji + this.otherxiaoji2).toFixed(2)
      this.heji3 = (this.cailiao + this.rengongxiaoji + this.otherxiaoji3).toFixed(2)
      this.heji4 = (this.cailiao + this.rengongxiaoji + this.otherxiaoji4).toFixed(2)
      this.heji5 = (this.cailiao + this.rengongxiaoji + this.otherxiaoji5).toFixed(2)
      this.heji6 = (this.cailiao + this.rengongxiaoji + this.otherxiaoji6).toFixed(2)
    },
    divided (num1, num2) {
      num1 = Number(num1)
      num2 = Number(num2)
      if (num2 < 0.00001) {
        return 0
      } else {
        return Number((num1 / num2).toFixed(2))
      }
    },
    pnum (num) {
      return Number(Number(num).toFixed(2))
    }
  }
}
</script>

<style lang="less" scoped>

.rt-input /deep/ .el-input__inner {
  color: rgb(0, 0, 0) !important;
  cursor: pointer;
}

.case{
    width: 1077px;
    height: 641px;
    position: relative;
}

.caseimg1{
  width: 1077px;
  height: 641px;
  position: absolute;
  z-index: 10;
}

.caseword{
  color:#000000;
  font-size: 18px;
}

.num1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 0px;
  width: 145px;
}

.num2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 0px;
  width: 145px;
}

.num3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 0px;
  width: 145px;
}

.num4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 0px;
  width: 145px;
}

.num5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 0px;
  width: 145px;
}

.num6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 0px;
  width: 145px;
}

.quantity1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 40px;
  width: 145px;
}

.quantity2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 40px;
  width: 145px;
}

.quantity3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 40px;
  width: 145px;
}

.quantity4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 40px;
  width: 145px;
}

.quantity5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 40px;
  width: 145px;
}

.quantity6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 40px;
  width: 145px;
}

.cailiao1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 80px;
  width: 145px;
}

.cailiao2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 80px;
  width: 145px;
}

.cailiao3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 80px;
  width: 145px;
}

.cailiao4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 80px;
  width: 145px;
}

.cailiao5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 80px;
  width: 145px;
}

.cailiao6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 80px;
  width: 145px;
}

.unitoftime1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 120px;
  width: 145px;
}

.unitoftime2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 120px;
  width: 145px;
}

.unitoftime3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 120px;
  width: 145px;
}

.unitoftime4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 120px;
  width: 145px;
}

.unitoftime5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 120px;
  width: 145px;
}

.unitoftime6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 120px;
  width: 145px;
}

.hourlywage1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 160px;
  width: 145px;
}

.hourlywage2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 160px;
  width: 145px;
}

.hourlywage3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 160px;
  width: 145px;
}

.hourlywage4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 160px;
  width: 145px;
}

.hourlywage5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 160px;
  width: 145px;
}

.hourlywage6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 160px;
  width: 145px;
}

.rengongxiaoji1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 200px;
  width: 145px;
}

.rengongxiaoji2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 200px;
  width: 145px;
}

.rengongxiaoji3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 200px;
  width: 145px;
}

.rengongxiaoji4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 200px;
  width: 145px;
}

.rengongxiaoji5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 200px;
  width: 145px;
}

.rengongxiaoji6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 200px;
  width: 145px;
}

.mouldcost1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 240px;
  width: 145px;
}

.mouldcost2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 240px;
  width: 145px;
}

.mouldcost3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 240px;
  width: 145px;
}

.mouldcost4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 240px;
  width: 145px;
}

.mouldcost5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 240px;
  width: 145px;
}

.mouldcost6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 240px;
  width: 145px;
}

.mouldcostdanwei1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 280px;
  width: 145px;
}

.mouldcostdanwei2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 280px;
  width: 145px;
}

.mouldcostdanwei3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 280px;
  width: 145px;
}

.mouldcostdanwei4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 280px;
  width: 145px;
}

.mouldcostdanwei5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 280px;
  width: 145px;
}

.mouldcostdanwei6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 280px;
  width: 145px;
}

.developmentfee1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 320px;
  width: 145px;
}

.developmentfee2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 320px;
  width: 145px;
}

.developmentfee3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 320px;
  width: 145px;
}

.developmentfee4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 320px;
  width: 145px;
}

.developmentfee5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 320px;
  width: 145px;
}

.developmentfee6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 320px;
  width: 145px;
}

.developmentfeedanwei1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 360px;
  width: 145px;
}

.developmentfeedanwei2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 360px;
  width: 145px;
}

.developmentfeedanwei3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 360px;
  width: 145px;
}

.developmentfeedanwei4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 360px;
  width: 145px;
}

.developmentfeedanwei5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 360px;
  width: 145px;
}

.developmentfeedanwei6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 360px;
  width: 145px;
}

.zulingfei1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 400px;
  width: 145px;
}

.zulingfei2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 400px;
  width: 145px;
}

.zulingfei3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 400px;
  width: 145px;
}

.zulingfei4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 400px;
  width: 145px;
}

.zulingfei5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 400px;
  width: 145px;
}

.zulingfei6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 400px;
  width: 145px;
}

.dianfei1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 440px;
  width: 145px;
}

.dianfei2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 440px;
  width: 145px;
}

.dianfei3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 440px;
  width: 145px;
}

.dianfei4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 440px;
  width: 145px;
}

.dianfei5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 440px;
  width: 145px;
}

.dianfei6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 440px;
  width: 145px;
}

.freight1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 480px;
  width: 145px;
}

.freight2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 480px;
  width: 145px;
}

.freight3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 480px;
  width: 145px;
}

.freight4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 480px;
  width: 145px;
}

.freight5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 480px;
  width: 145px;
}

.freight6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 480px;
  width: 145px;
}

.other1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 520px;
  width: 145px;
}

.other2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 520px;
  width: 145px;
}

.other3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 520px;
  width: 145px;
}

.other4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 520px;
  width: 145px;
}

.other5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 520px;
  width: 145px;
}

.other6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 520px;
  width: 145px;
}

.otherxiaoji1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 560px;
  width: 145px;
}

.otherxiaoji2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 560px;
  width: 145px;
}

.otherxiaoji3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 560px;
  width: 145px;
}

.otherxiaoji4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 560px;
  width: 145px;
}

.otherxiaoji5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 560px;
  width: 145px;
}

.otherxiaoji6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 560px;
  width: 145px;
}

.heji1{
  position: absolute;
  z-index: 30;
  left: 185px;
  top: 600px;
  width: 145px;
}

.heji2{
  position: absolute;
  z-index: 30;
  left: 334px;
  top: 600px;
  width: 145px;
}

.heji3{
  position: absolute;
  z-index: 30;
  left: 483px;
  top: 600px;
  width: 145px;
}

.heji4{
  position: absolute;
  z-index: 30;
  left: 633px;
  top: 600px;
  width: 145px;
}

.heji5{
  position: absolute;
  z-index: 30;
  left: 781px;
  top: 600px;
  width: 145px;
}

.heji6{
  position: absolute;
  z-index: 30;
  left: 930px;
  top: 600px;
  width: 145px;
}
</style>
